import { Laptop, Moon, Sun } from 'lucide-react'
import { Button } from './ui/button'
import { useUiStore } from '@/stores/ui-store'
import { useI18n } from '@/i18n/i18n'

export function ThemeToggle() {
  const { t } = useI18n()
  const { theme, setTheme } = useUiStore()
  const next = theme === 'system' ? 'light' : theme === 'light' ? 'dark' : 'system'
  const Icon = theme === 'system' ? Laptop : theme === 'light' ? Sun : Moon
  return <Button variant="ghost" size="icon" onClick={() => setTheme(next)} aria-label={t('settings.theme')}><Icon className="size-[18px]" /></Button>
}
